import { FormProvider } from 'react-hook-form';
import { ClipboardCheckFillIcon } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useRouter } from 'next/router';
import { parseQuoteSegment, QUOTE_SEGMENT_QUERY_KEY, type QuoteSegment } from './constants/quizQuote.const';
import { QuizQuoteForm, QuotePreviewAside } from './components';
import { useQuizQuoteForm, useQuoteSubmit } from './hooks';

/**
 * 견적서 발행 페이지(Phase 1a, Figma 13614-55850).
 *
 * External Platform: 견적은 normal Quiz 세일즈 플로우다. LTI/Google Classroom 은
 * assignment-scoped 라 이 진입점(프라이싱) 자체가 노출되지 않으므로 별도 분기 없음.
 */
export function QuotePageView() {
  const router = useRouter();
  if (!router.isReady) {
    return null;
  }
  const segment = parseQuoteSegment(router.query[QUOTE_SEGMENT_QUERY_KEY]);
  return <QuotePageContent segment={segment} data-sentry-element="QuotePageContent" data-sentry-component="QuotePageView" data-sentry-source-file="QuotePageView.tsx" />;
}
function QuotePageContent({
  segment
}: {
  segment: QuoteSegment;
}) {
  const methods = useQuizQuoteForm(segment);
  const submit = useQuoteSubmit(methods.setError, methods.clearErrors);
  return <div className="flex min-h-screen justify-center bg-neutral px-4 py-10" data-sentry-component="QuotePageContent" data-sentry-source-file="QuotePageView.tsx">
      <div className="w-full max-w-[1000px]">
        <div className="mb-xl flex items-center gap-2xs">
          <ClipboardCheckFillIcon size="lg" fill={ICON_COLOR.default} data-sentry-element="ClipboardCheckFillIcon" data-sentry-source-file="QuotePageView.tsx" />
          <h1 className="text-heading-lg-extrabold text-default">
            견적서 발행
          </h1>
        </div>

        <FormProvider {...methods} data-sentry-element="FormProvider" data-sentry-source-file="QuotePageView.tsx">
          <form noValidate onSubmit={methods.handleSubmit(submit)} className="flex flex-col gap-lg tablet-lg:flex-row tablet-lg:items-start tablet-lg:gap-[40px]">
            <div className="w-full tablet-lg:min-w-0 tablet-lg:flex-1">
              <QuizQuoteForm data-sentry-element="QuizQuoteForm" data-sentry-source-file="QuotePageView.tsx" />
            </div>
            <div className="w-full tablet-lg:w-[400px] tablet-lg:shrink-0">
              <QuotePreviewAside data-sentry-element="QuotePreviewAside" data-sentry-source-file="QuotePageView.tsx" />
            </div>
          </form>
        </FormProvider>
      </div>
    </div>;
}